import { useContext } from "react";
import { useLocation } from "react-router-dom";
import AroundCircle from "src/components/AroundCircle/AroundCircle";
import Page from "src/components/Report/Page";
import jobContext from "src/context/jobContext";
import { shayestegiha } from "src/data/shayestegiha";

export default function Pageb5({ reload }) {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");

    const { job } = useContext(jobContext)
    let shayestegihayeOmoomi;
    let count = 0


    if (JSON.parse(localStorage?.data)?.[jobId]?.shayestegihayeOmoomi) {
        shayestegihayeOmoomi = JSON.parse(localStorage?.data)?.[jobId]?.shayestegihayeOmoomi
    } else {
        shayestegihayeOmoomi = []
    }
    // console.log(shayestegihayeOmoomi);
    let dataArray = []
    Object.keys(shayestegihayeOmoomi).map((key, index) => {
        if (shayestegihayeOmoomi[key].value >= 5) {
            dataArray.push(key);
        }
    })

    return (
        <Page pageNumber={13}>
            <div className="font-bold text-lg">
                مدل شایستگی عمومی {job.title}
            </div>
            <div className="flex flex-col ml-20 my-0">
                <AroundCircle title={`شایستگی عمومی ${job.title}`} dataArray={dataArray} reload={reload} />
            </div>

            <div className="bg-blue-600 grid grid-cols-6 w-full justify-between text-white p-3 py-2 rounded-sm mt-32">
                <div className="text-center w-full">عنوان شایستگی</div>
                <div className="col-span-2 text-center w-full">شرح شایستگی</div>
                <div className="text-center w-full">مولفه‌های شایستگی</div>
                <div className="text-center w-full">برنامه توسعه</div>
                <div className="text-center w-full">آزمون/ابزار</div>
            </div>
            <div className="grid grid-cols-6 gap-0 w-full rounded-md -mt-6">
                {
                    Object.keys(shayestegihayeOmoomi).map((key, index) => {
                        if (shayestegihayeOmoomi[key].value >= 5 && count < 5) {
                            count += 1;
                            return (
                                <>
                                    <div className="w-full border borde-solid border-gray-300 p-2 rounded-sm text-sm font-semibold">{key}</div>
                                    <div className="col-span-2 w-full border borde-solid border-gray-300 p-2 rounded-sm text-[11px]">{shayestegiha[key].desc}</div>
                                    <div className="w-full border borde-solid border-gray-300 p-2 rounded-sm text-[11px]">{shayestegiha[key].moalefe.toString(" ")}</div>
                                    <div className="w-full border borde-solid border-gray-300 p-2 rounded-sm text-[11px]">{shayestegiha[key].amoozesh.toString(" ")}</div>
                                    <div className="w-full border borde-solid border-gray-300 p-2 rounded-sm text-[11px]">{shayestegiha[key].abzar.toString(" ")}</div>
                                </>
                            )
                        }
                    })
                }
            </div>
        </Page>
    )
}